import React from "react";

export const Header = (props) => {
  const calendlyLink = "https://calendly.com/rashid-a";

  return (
    <header id="header">
      <div className="hero-grid" aria-hidden="true"></div>
      <div className="hero-orbs" aria-hidden="true">
        <div className="hero-orb hero-orb--1"></div>
        <div className="hero-orb hero-orb--2"></div>
        <div className="hero-orb hero-orb--3"></div>
      </div>
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text text-center">
                <span className="hero-eyebrow">
                  <span className="hero-eyebrow-dot"></span>
                  Applied AI consulting
                </span>
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href={calendlyLink}
                  className="btn btn-custom btn-lg page-scroll"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book A Free Consultation
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
